import { render, staticRenderFns } from "./ConfigTabDivisions.vue?vue&type=template&id=55528d76"
import script from "./ConfigTabDivisions.vue?vue&type=script&lang=js"
export * from "./ConfigTabDivisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports